<template>
    <ion-icon :color="colour" :icon="ellipse"></ion-icon>
</template>

<script>

import {IonIcon} from '@ionic/vue';
import {ellipse} from 'ionicons/icons';
export default {
    props: ['priority'],
    name: "ColourCodedPriorityIcon",
    components: {IonIcon},
    computed: {
        colour() {
            switch (this.priority.toLowerCase()) {
                case 'low':
                    return 'light';
                case 'medium':
                    return 'warning';
                case 'high':
                    return 'danger';
                case 'urgent':
                    return 'dark';
            }
            return 'primary';
        }
    },
    setup() {
        return {
            ellipse
        };
    }
}
</script>

<style scoped>

</style>
